import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib';
import { Sexo } from './entity-sexo.model';

export const entitytSexoAdapter: EntityAdapter<Sexo> =
  createEntityAdapter<Sexo>({
    selectId: (model) => model.id,
    sortComparer: (a: Sexo, b: Sexo): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntitySexoState extends EntityState<Sexo> {
  isLoading?: boolean;
  hasAddedSuccess?: boolean;
  error?: Error | null | any;
}

export const initialState: EntitySexoState =
  entitytSexoAdapter.getInitialState({
    hasAddedSuccess: false,
    isLoading: false,
    error: null
  });
